import { Link } from "react-router-dom";
import { Calendar, Tag } from "lucide-react";
import { Seo } from "@/components/Seo";
import { Breadcrumbs } from "@/components/Breadcrumbs";
import { CtaSection } from "@/components/CtaSection";
import { COMPANY } from "@/data/company";
import { POSTS } from "@/data/blog";
import { breadcrumbSchema } from "@/lib/schema";

const fmtData = (d) => new Date(d + "T12:00:00").toLocaleDateString("pt-BR", { day: "2-digit", month: "long", year: "numeric" });

export default function BlogPostPage({ post }) {
  const url = `/blog/${post.slug}`;
  const crumbs = [
    { name: "Início", url: "/" },
    { name: "Blog", url: "/blog" },
    { name: post.titulo, url },
  ];
  const articleSchema = {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    headline: post.titulo,
    description: post.descricao,
    image: `${COMPANY.dominio}${post.image}`,
    datePublished: post.data,
    author: { "@type": "Organization", name: COMPANY.nome },
    publisher: { "@type": "Organization", name: COMPANY.nome, url: COMPANY.dominio },
    mainEntityOfPage: `${COMPANY.dominio}${url}`,
  };
  const outros = POSTS.filter((p) => p.slug !== post.slug).slice(0, 3);

  return (
    <main className="max-w-4xl mx-auto px-4 md:px-8" data-testid="blog-post-page">
      <Seo title={`${post.titulo} | Desentupidora em Guarulhos`} description={post.descricao} path={url} image={post.image} jsonLd={[articleSchema, breadcrumbSchema(crumbs)]} />
      <Breadcrumbs items={[crumbs[0], crumbs[1], { name: post.categoria, url }]} />
      <article>
        <div className="flex items-center gap-4 text-xs text-gray-500 mt-2 mb-3">
          <span className="flex items-center gap-1"><Tag size={13} className="text-brand-red" /> {post.categoria}</span>
          <span className="flex items-center gap-1"><Calendar size={13} /> {fmtData(post.data)}</span>
        </div>
        <h1 className="font-heading font-black text-2xl sm:text-3xl lg:text-4xl text-brand-dark tracking-tight leading-tight">{post.titulo}</h1>
        <img src={post.image} alt={post.titulo} width="1264" height="848" className="rounded-2xl shadow-md w-full my-7" />
        {post.conteudo.map((sec, i) => (
          <section key={i} className="mb-8">
            <h2 className="font-heading font-black text-xl md:text-2xl text-brand-dark tracking-tight mb-4">{sec.h2}</h2>
            {sec.p.map((par, j) => (
              <p key={j} className="text-gray-700 text-sm md:text-base leading-relaxed mb-3">{par}</p>
            ))}
          </section>
        ))}
      </article>

      <section className="border-t border-gray-100 pt-8 pb-4" data-testid="outros-artigos">
        <h2 className="font-heading font-bold text-xl text-brand-dark uppercase tracking-tight mb-4">Leia também</h2>
        <ul className="space-y-2">
          {outros.map((p) => (
            <li key={p.slug}>
              <Link to={`/blog/${p.slug}`} className="text-brand-red font-medium text-sm hover:underline" data-testid={`outro-post-${p.slug}`}>{p.titulo}</Link>
            </li>
          ))}
        </ul>
      </section>

      <CtaSection titulo="Fale com um especialista agora" texto="Atendimento 24 horas em todos os bairros de Guarulhos. Orçamento gratuito e preço fechado pelo WhatsApp." />
    </main>
  );
}
